import { createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { RequestStatusEnum } from '@shared/types';
import { Team } from '../types';

export type TeamsState = {
    teams: Team[];
    getTeamsStatus: RequestStatusEnum;
    getTeamsError: AxiosError | null;
};

const initialState: TeamsState = {
    teams: [],
    getTeamsStatus: RequestStatusEnum.NotRequested,
    getTeamsError: null,
};

const teamsSlice = createSlice({
    name: '@teams',
    initialState,
    reducers: {
        getTeamsRequest(state) {
            state.getTeamsStatus = RequestStatusEnum.Loading;
            state.getTeamsError = null;
        },
        getTeamsSuccess(state, action) {
            state.getTeamsStatus = RequestStatusEnum.Success;
            state.getTeamsError = null;
            state.teams = action.payload.data;
        },
        getTeamsError(state, action) {
            state.getTeamsStatus = RequestStatusEnum.Error;
            state.getTeamsError = action.payload;
            state.teams = [];
        },
        getTeamsReset(state) {
            state.getTeamsStatus = RequestStatusEnum.NotRequested;
            state.getTeamsError = null;
            state.teams = [];
        },
    },
});

export default teamsSlice.reducer;

export const { getTeamsRequest, getTeamsSuccess, getTeamsError, getTeamsReset } = teamsSlice.actions;
